module.exports = function(pages) {
	"use strict";
  pages
  .controller('pageController', pageController)
	pageController.$inject = ["postDataService","$state","alertService","$http","API_URL","$scope","getDataService", "jQuery","refreshtokenService","config","$attrs","$rootScope","$filter","cleanObj","$timeout","activeClass","serverError","offlineError"];
	
  function pageController(postDataService,$state,alertService,$http,API_URL,$scope,getDataService,jQuery,refreshtokenService,config,$attrs,$rootScope,$filter,cleanObj,$timeout,activeClass,serverError,offlineError) {
    var vmpg = this;
    var parent = $scope.$eval($attrs.parent);
    vmpg.newPost = true;
    vmpg.postId = false;
    vmpg.hasFeaturedImage = false;
    vmpg.config = config;
    vmpg.editSlugShow = false;
    vmpg.setFeaturedImageShow = false;
    vmpg.selectedPostStatus = {value:''}
    vmpg.featured_img = undefined;
    vmpg.changeImageTrue = false;
    vmpg.insertMediatoEditor = false;
    vmpg.mediaModal = false;
    vmpg.setFeaturedImage = false;
    vmpg.insertMediatoEditor = false;
    vmpg.editPostStatusShow = false;
    vmpg.newTagRequired = false;
    vmpg.titleRequired = false; 
    vmpg.featured_img_id;
    vmpg.singleView = true;
    vmpg.statusDraft = true;
    vmpg.dataPost = {};
    vmpg.dataPost.tags = [];
    vmpg.editorPreviewVisual = true;
    vmpg.editPostDateShow = false;
    vmpg.cropModalShow = false;
    vmpg.mediaLibrary = true;
    vmpg.scheduledPost = false;
    var updateDate = null;
    vmpg.data_grid =[];
    vmpg.selectedPhotoQuality={value:'medium'};
    jQuery(document).on('click','.upload-image',function() {
      $scope.$apply(function() {
          vmpg.mediaLibrary = true;
      })
    });
    vmpg.saveAttachments = function() {
      $scope.$broadcast('attachment-save');
    }
    vmpg.openCropModal = function() {
      vmpg.cropModalShow = true;
    }
    vmpg.cancelCropModal = function() {
      vmpg.cropModalShow = false;
      $rootScope.modalShow = false;
    }
    var parseOptions = function (stringOptions) {
          var options = {}, set;
          if (!stringOptions) { return; }

          set = stringOptions
              .replace(/(\w+=)/g, '\n$1')
              .split('\n');
              set.shift();

          for (var i = 0; i < set.length; i++) {
              var kv = set[i].split('=');
              options[kv[0]] = kv[1].replace(/\'|\"/g, '').trim();
          }

          return options;
      };
    var publishPostFunction = function(url,state) {
      var validatePublish = true;
      vmpg.content = vmpg.textEditorContent;
      var updateDataPost = {
        "title": vmpg.dataPost.title,
        "subtitle": vmpg.dataPost.subtitle,
        "content": vmpg.content,
        "slug": vmpg.postSlug,
        "image": vmpg.featured_img_id,
        "status": vmpg.dataPost.status,
        "date": updateDate,
      }
      cleanObj.clean(updateDataPost);
      var putFunction = function() {
        $rootScope.hasLoaded = false;
        $http.put(url , updateDataPost)
        .success(function (data, status, headers) {
          alertService('success','Success ', data.message, 2000);
          $rootScope.hasLoaded = true;
          if(vmpg.dataPost.status !='publish') {
            vmpg.editPublish = false;
          }
          $timeout(function() {
            if(vmpg.newPost) {
              $state.go('app.allpages',{id:vmpg.postId});
            }
          },1000);
          if(state=='trash') {
            parent.editPostShow = false;
            $state.transitionTo('app.allpages', {id: null}, {
              location: true,
              inherit: true,
              relative: $state.$current,
              notify: false
            });
          }
        })
        .error(function (data, status, header, config) {
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  putFunction();
                }
              },
              function(error) {
              },
              function(progress) {
               // report progress
            });
          }else if(status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.'); 
          }
          $rootScope.hasLoaded = true;
        }); 
      }
     
      if(vmpg.dataPost.title) {
        vmpg.titleRequired = false;
      } else {
        vmpg.titleRequired = true;
        alertService('danger','Opps! ', 'Title is required');
        validatePublish = false;
      }
      if(!updateDate) {
        updateDate = moment().toISOString();
      }

      if(validatePublish) {
        putFunction();
        
      }
      
    }


    vmpg.publishPost = function() {
      
      vmpg.dataPost.status = 'publish';
      publishPostFunction(API_URL+ "pages/"+vmpg.postId);
    }
    vmpg.trashPost = function() {
      vmpg.dataPost.status = 'trash';
      publishPostFunction(API_URL+ "pages/"+vmpg.postId,'trash');
    }
    vmpg.updateorSavePost =  function() {
      publishPostFunction(API_URL+ "pages/"+vmpg.postId);
    }
    vmpg.editPostStatus = function() {
      vmpg.editPostStatusShow = true;
    }
    vmpg.editPostTime = function() {
      vmpg.editPostDateShow = true;
      if(vmpg.newPost || (!vmpg.editPublish && !vmpg.scheduledPost)) {
        convertTimeFunction(undefined);
      } 
    }
    
    vmpg.changePostStatus = function() {
      vmpg.editPostStatusShow = false;
      vmpg.dataPost.status = vmpg.selectedPostStatus.value;
    }
    vmpg.cancelEditPostStatus = function() {
      vmpg.editPostStatusShow = false;
      vmpg.selectedPostStatus = {value: vmpg.dataPost.status};
    }
    
    vmpg.editorChangePreviw = function(event, editorPreview) {
      activeClass.active(event);
      $scope.$broadcast("change-editor",{editor_preview:editorPreview});
      if(editorPreview == 'text') {
        vmpg.editorPreviewVisual = false;
      } else {
        vmpg.editorPreviewVisual = true;
      }    
    }
    $rootScope.$on("edit-image",function(event, data) {
      vmpg.editImageObj = data.editImageObj;
      vmpg.editImagefromEditor = true;
    });
    vmpg.addMediatoEditor = function() {
      vmpg.mediaModal = true;
      vmpg.insertMediatoEditor = true;
      vmpg.setFeaturedImage = false;
      vmpg.editImagefromEditor = false;
    }
    vmpg.openSetFeaturedImage = function() {
      vmpg.mediaModal = true;
      vmpg.setFeaturedImage = true;
      vmpg.insertMediatoEditor = false;
      vmpg.editImagefromEditor = false;
    };
    vmpg.cancelImageModal = function() {
      vmpg.mediaModal = false;
      vmpg.editImagefromEditor = false; 
      $rootScope.modalShow = false;
    }
    
    $scope.$watchCollection(function(){
        return vmpg.changeImageTrue
      }, function(newValue, oldValue){
        if (newValue) {
          $scope.$broadcast("change-image",{afterImage:true});
        }
      },true);
    vmpg.editSlug = function(slug) {
      vmpg.copySlug = angular.copy(slug);
      vmpg.editSlugShow = true;
    }
    vmpg.cancelSlug = function() {
      vmpg.postSlug = vmpg.copySlug;
      if(!vmpg.postSlug) {
        vmpg.postSlug = '';
      } 
      vmpg.editSlugShow = false; 
    }
    vmpg.updateSlug = function(slug) {
      vmpg.editSlugShow = false; 
    }
    vmpg.removeFeaturedImage = function() {
      vmpg.hasFeaturedImage = false;
      vmpg.featured_img_id = undefined;
      vmpg.featured_img_obj = undefined;
    }
    vmpg.cancelEditPostDate = function() {
      vmpg.editPostDateShow = false; 
    }
    vmpg.setPublishedDate = function() {
      vmpg.editPostDateShow = false; 
      var dateArray = [vmpg.postYear, parseInt(vmpg.selectedPostMont.value)-1, vmpg.postDay, vmpg.postHours, vmpg.postMinutes];
      if(moment(dateArray).diff(moment())>0) {
        vmpg.scheduledPost = true;
      } else {
        vmpg.scheduledPost = false;
      }
      updateDate = moment(dateArray).toISOString();
      vmpg.dataPost.date = $filter('date')(updateDate, "MMM d, y H:mm");
    }
    var convertTimeFunction = function(date) {
      var a = moment(date);
      var year = a.format('YYYY');
      var month = a.format('M');
      var day = a.format('D');
      var hour = a.hours();
      var min = a.minutes();
      var sec = a.seconds();
      vmpg.postYear = year;
      vmpg.selectedPostMont = {value: month};
      vmpg.postDay = day;
      vmpg.postHours = hour;
      vmpg.postMinutes = min;
    } 
    vmpg.editPostFunction = function() {
      $rootScope.hasLoaded = true;
      vmpg.scheduledPost = false;
      vmpg.editPublish =false;
      if(vmpg.dataPost.date) {
        if(moment(vmpg.dataPost.date).diff(moment())> 0){
          vmpg.scheduledPost = true;
        }
        updateDate = vmpg.dataPost.date;
      }
      vmpg.dataPost.date = $filter('date')(vmpg.dataPost.date, "MMM d, y H:mm");
      convertTimeFunction(vmpg.dataPost.date);
      if(vmpg.dataPost.status == 'publish') {
        vmpg.editPublish = true;
      } else if(vmpg.dataPost.status=='trash') {
        parent.editPostShow = false;
        $state.transitionTo('app.allpages', {id: null}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          notify: false
        });
      }
      vmpg.selectedPostStatus={value:vmpg.dataPost.status};
      var postContent = vmpg.dataPost.content;
      if(postContent) {

        postContent.replace(/\[caption([^\]]*)\]([^\]]*)\[\/caption\]/g, function(all, attr, con) {
            var parsetOpions = parseOptions(attr);
            // console.log(parsetOpions);
            postContent = postContent.replace( all,'<captionblock id="'+parsetOpions.id+'" align="'+parsetOpions.align+'" width="' +parsetOpions.width +'">'+con+'</captionblock>');
        });

        postContent = wpautop(postContent);
        vmpg.tinymceModel = postContent;
      }
      
      vmpg.postSlug = vmpg.dataPost.slug;
      if(vmpg.dataPost.slug && vmpg.dataPost.uri) {
        var slugLength = vmpg.dataPost.slug.length;
        vmpg.substringUri = vmpg.dataPost.uri.substr(0, vmpg.dataPost.uri.length-slugLength);
      }
      if(vmpg.dataPost.image) {
        vmpg.hasFeaturedImage = true;
        vmpg.featured_img_file = vmpg.dataPost.image.file;
        vmpg.featured_img_obj = vmpg.dataPost.image;
      }
    }
    if(parent) {
      vmpg.postId = parent.post_id;
    }
     
    if(vmpg.postId) {
      vmpg.newPost = false;
      $rootScope.closeEditPage = function() {
        $rootScope.ngEscapeAttrsParametars = [];
        parent.editPostShow = false;
        vmpg.dataPost = null;
        $rootScope.hasLoaded = true;
        $state.transitionTo('app.allpages', {id: null}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          notify: false
        });
      }
      var getPostData = function() { 
         $rootScope.hasLoaded = false;
        getDataService.get({param1:'pages', param2: vmpg.postId}).$promise.then(function(dataPosts){
          $rootScope.hasLoaded = true;
          vmpg.dataPost = dataPosts;
          vmpg.editPostFunction();
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getPostData();
                }
                // do something
              },
              function(error) {
              },
              function(progress) {
               // report progress
              });
            } else if(error.status ==502) {
              serverError()
            }else {
              parent.editPostShow = false;
              vmpg.dataPost = null;
              $rootScope.hasLoaded = true;
              $state.transitionTo('app.allpages', {id: null}, {
                location: true,
                inherit: true,
                relative: $state.$current,
                notify: false
              });
            }
        });
      } 
      getPostData();  
      
    } else {
      vmpg.dataPost.status = 'draft';
      vmpg.selectedPostStatus={value:'draft'};
      $rootScope.hasLoaded = true;
      var getNewPostData = function() {
        postDataService.save({
          param1:'pages' 
        }).$promise.then(function(data){
           vmpg.postId = data.page._id;
           vmpg.postDate = data.page.date;
           convertTimeFunction(vmpg.postDate);
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getNewPostData();
                }
                // do something
              },
              function(error) {
              },
              function(progress) {
               // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else {
              $rootScope.hasLoaded = true;
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }
        });
      } 
      getNewPostData();
    }
    $scope.$on('$destroy', function() {
      vmpg.singleView = null;
    });
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }   
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/pagesModule/edit-newpage/js/pageController.js
// module id = 538
// module chunks = 0